module.exports = __webpack_public_path__ + "img/trending-down.49127a40.svg";